import { render, staticRenderFns } from "./RoleAvatar.vue?vue&type=template&id=51f33b5c&scoped=true&lang=pug"
import script from "./RoleAvatar.vue?vue&type=script&lang=js"
export * from "./RoleAvatar.vue?vue&type=script&lang=js"
import style0 from "./RoleAvatar.vue?vue&type=style&index=0&id=51f33b5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f33b5c",
  null
  
)

export default component.exports